import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import  initial  from "../assets/initial.mp3";


const InitialView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hexInput = location.state.hexkey;
  //const KeyValue = location.state.KeyValue;

  const firstpage = () => {
    navigate("/input");
  };

  const secondpage = () => {
    navigate("/round", { state: { allResults } });
  };

  function createArrayInOrder(hexInput) {
    // Split the input string into individual hex values
    const hexValues = hexInput.split(" ");

    // Initialize an array to store the elements in the desired order
    const orderedArray = [];

    // Determine the number of elements and the number of columns
    const numElements = hexValues.length;
    const numColumns = 4;

    for (let column = 0; column < numColumns; column++) {
      for (let row = 0; row < numElements; row += numColumns) {
        const index = row + column;
        if (index < numElements) {
          orderedArray.push(hexValues[index]);
        }
      }
    }

    return orderedArray;
  }

  function splitHexValue(hexValue) {
    // Split the input hexValue into individual hex values
    const hexValues = hexValue.split(" ");

    // Initialize variable arrays w0, w1, w2, and w3
    const w0 = hexValues.slice(0, 4);
    const w1 = hexValues.slice(4, 8);
    const w2 = hexValues.slice(8, 12);
    const w3 = hexValues.slice(12, 16);

    return { w0, w1, w2, w3 };
  }

  const orderedArray = createArrayInOrder(hexInput);
  console.log("array: ", orderedArray);
  const { w0, w1, w2, w3 } = splitHexValue(hexInput);

  const rows = [];
  for (let i = 0; i < orderedArray.length; i += 4) {
    rows.push(orderedArray.slice(i, i + 4));
  }
  console.log("rows: ", rows);

  function RotWord(word) {
    if (word.length !== 4) {
      throw new Error("Input word array must contain exactly 4 elements.");
    }

    // Create a new array for the rotated word
    const rotatedWord = [...word]; // Copy the elements from the original array

    // Perform the RotWord operation (left circular shift) on the new array
    const temp = rotatedWord[0];
    for (let i = 0; i < 3; i++) {
      rotatedWord[i] = rotatedWord[i + 1];
    }
    rotatedWord[3] = temp;

    return rotatedWord;
  }

  const rotatedWord = RotWord(w3);

  const sBox = [
    "63",
    "7C",
    "77",
    "7B",
    "F2",
    "6B",
    "6F",
    "C5",
    "30",
    "01",
    "67",
    "2B",
    "FE",
    "D7",
    "AB",
    "76",
    "CA",
    "82",
    "C9",
    "7D",
    "FA",
    "59",
    "47",
    "F0",
    "AD",
    "D4",
    "A2",
    "AF",
    "9C",
    "A4",
    "72",
    "C0",
    "B7",
    "FD",
    "93",
    "26",
    "36",
    "3F",
    "F7",
    "CC",
    "34",
    "A5",
    "E5",
    "F1",
    "71",
    "D8",
    "31",
    "15",
    "04",
    "C7",
    "23",
    "C3",
    "18",
    "96",
    "05",
    "9A",
    "07",
    "12",
    "80",
    "E2",
    "EB",
    "27",
    "B2",
    "75",
    "09",
    "83",
    "2C",
    "1A",
    "1B",
    "6E",
    "5A",
    "A0",
    "52",
    "3B",
    "D6",
    "B3",
    "29",
    "E3",
    "2F",
    "84",
    "53",
    "D1",
    "00",
    "ED",
    "20",
    "FC",
    "B1",
    "5B",
    "6A",
    "CB",
    "BE",
    "39",
    "4A",
    "4C",
    "58",
    "CF",
    "D0",
    "EF",
    "AA",
    "FB",
    "43",
    "4D",
    "33",
    "85",
    "45",
    "F9",
    "02",
    "7F",
    "50",
    "3C",
    "9F",
    "A8",
    "51",
    "A3",
    "40",
    "8F",
    "92",
    "9D",
    "38",
    "F5",
    "BC",
    "B6",
    "DA",
    "21",
    "10",
    "FF",
    "F3",
    "D2",
    "CD",
    "0C",
    "13",
    "EC",
    "5F",
    "97",
    "44",
    "17",
    "C4",
    "A7",
    "7E",
    "3D",
    "64",
    "5D",
    "19",
    "73",
    "60",
    "81",
    "4F",
    "DC",
    "22",
    "2A",
    "90",
    "88",
    "46",
    "EE",
    "B8",
    "14",
    "DE",
    "5E",
    "0B",
    "DB",
    "E0",
    "32",
    "3A",
    "0A",
    "49",
    "06",
    "24",
    "5C",
    "C2",
    "D3",
    "AC",
    "62",
    "91",
    "95",
    "E4",
    "79",
    "E7",
    "C8",
    "37",
    "6D",
    "8D",
    "D5",
    "4E",
    "A9",
    "6C",
    "56",
    "F4",
    "EA",
    "65",
    "7A",
    "AE",
    "08",
    "BA",
    "78",
    "25",
    "2E",
    "1C",
    "A6",
    "B4",
    "C6",
    "E8",
    "DD",
    "74",
    "1F",
    "4B",
    "BD",
    "8B",
    "8A",
    "70",
    "3E",
    "B5",
    "66",
    "48",
    "03",
    "F6",
    "0E",
    "61",
    "35",
    "57",
    "B9",
    "86",
    "C1",
    "1D",
    "9E",
    "E1",
    "F8",
    "98",
    "11",
    "69",
    "D9",
    "8E",
    "94",
    "9B",
    "1E",
    "87",
    "E9",
    "CE",
    "55",
    "28",
    "DF",
    "8C",
    "A1",
    "89",
    "0D",
    "BF",
    "E6",
    "42",
    "68",
    "41",
    "99",
    "2D",
    "0F",
    "B0",
    "54",
    "BB",
    "16",
  ];

  function SubWord(rotWord) {
    if (rotWord.length !== 4) {
      throw new Error("Input word array must contain exactly 4 elements.");
    }

    // Apply the S-Box transformation to each byte of the RotWord
    const subWord = rotWord.map((byte) => sBox[parseInt(byte, 16)]);

    return subWord;
  }

  const subWord = SubWord(rotatedWord);
  console.log("sub", subWord);

  const roundConstants = [
    ["01", "00", "00", "00"],
    ["02", "00", "00", "00"],
    ["04", "00", "00", "00"],
    ["08", "00", "00", "00"],
    ["10", "00", "00", "00"],
    ["20", "00", "00", "00"],
    ["40", "00", "00", "00"],
    ["80", "00", "00", "00"],
    ["1B", "00", "00", "00"],
    ["36", "00", "00", "00"],
  ];

  function AddRoundConstant(subWord, round) {
    if (subWord.length !== 4) {
      throw new Error("Input subWord array must contain exactly 4 elements.");
    }

    // Get the round constant for the specified round
    const roundConstant = roundConstants[round - 1];

    // XOR the SubWord with the round constant
    const gWi = subWord.map((byte, index) =>
      (parseInt(byte, 16) ^ parseInt(roundConstant[index], 16))
        .toString(16)
        .padStart(2, "0")
    );

    return gWi;
  }
  const round = 1;
  const gWi = AddRoundConstant(subWord, round);
  console.log("gWi", gWi);

  function XORWords(w0, gWi) {
    if (w0.length !== 4 || gWi.length !== 4) {
      throw new Error("Input arrays must contain exactly 4 elements.");
    }

    const w4 = w0.map((byte, index) =>
      (parseInt(byte, 16) ^ parseInt(gWi[index], 16))
        .toString(16)
        .padStart(2, "0")
    );

    return w4;
  }

  const w4 = XORWords(w0, gWi);
  const w5 = XORWords(w1, w4);
  const w6 = XORWords(w2, w5);
  const w7 = XORWords(w3, w6);
  console.log(w4, w5, w6, w7);

  let words = [w0, w1, w2, w3];
  let rotwordarray = [];
  let subwordarray = [];
  let gwiarray = [];
  let allResults = [];

  function AESkeyGeneration(hexInput) {
    let rotWordindex = 3;
    for (let i = 0; i < 10; i++) {
      let rotatedWord = RotWord(words[rotWordindex]);
      rotwordarray.push(rotatedWord);
      subwordarray.push(SubWord(rotatedWord));
      gwiarray.push(AddRoundConstant(SubWord(rotatedWord), i + 1));

      words.push(XORWords(words[rotWordindex - 3], gwiarray[i]));
      for (let j = 2; j > -1; j--) {
        words.push(XORWords(words[rotWordindex - j], words[words.length - 1]));
      }
      rotWordindex = rotWordindex + 4;
    }
    allResults.push(rotwordarray);
    allResults.push(subwordarray);
    allResults.push(gwiarray);
    allResults.push(words);
    allResults.push(hexInput);
  }

  AESkeyGeneration(hexInput);
  console.log(allResults);

  const toggleMute = () => {
    const audio = document.getElementById('audio');
    audio.muted = !audio.muted;
  };

  return (
    <>
    <div class="fixed top-16 right-10 h-4/5 w-1/5 rounded-xl bg-emerald-100 shadow p-4">
      <div class="text-center">
        <h2 className="text-xl pb-10 pt-4 font-semibold">Input to Hex</h2>
    <p class="text-sm">Here the Key value input you entered in the previous screen was converted to hex.<br /><br />
    This hex value is split into 4 words w0,w1,w2,w3 as you can see. <br /><br />
    This is used to find the other words which produce the Subkeys of AES.</p>

    <audio id="audio" controls className="mt-4 w-full">
          <source src={initial} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
        <button onClick={toggleMute} className="mt-2 bg-gray-300 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded">
          Mute
        </button>
    </div>
  </div>

    
      <div className="input-container">
        <div className="flex flex-col items-center">
          <div>
            <h1 className="text-3xl pt-8">Experiment 4 : AES Key Generation</h1>
          </div>
          <div className="pt-10">
            <h1>Hex Value: {hexInput}</h1>
            <br />
          </div>

            <motion.div initial={{scale:0}} animate={{scale:1}} transition={{delay:2.5}} className="flex flex-col">
              <p>Matrix Representation</p>
              <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out">
                {rows.map((row, rowIndex) => (
                  <div key={rowIndex} className="mb-2">
                    {row.map((element, elementIndex) => (
                      <span key={elementIndex}>
                        {element}
                        {elementIndex < row.length - 1 && (
                          <span className="mx-2"> </span>
                        )}
                      </span>
                    ))}
                  </div>
                ))}
              </div>
            </motion.div>
          <div className="flex flex-col">
            <table className="border-separate border-spacing-2 border border-slate-500 ...">
              <tr>
                <th>w0</th>
                <th>w1</th>
                <th>w2</th>
                <th>w3</th>
                <th>w4</th>
                <th>w5</th>
                <th>w6</th>
                <th>w7</th>
                <th>...</th>
                <th>...</th>
                <th>w43</th>
              </tr>

              <tr>
                <motion.div 
                initial={{x:100, y:-255, opacity:0.5}}
                animate={{x:0, y:0, opacity:1}}
                transition={{delay:3}}
                ><td>{rows[0][0]}</td></motion.div>
                <td>{rows[0][1]}</td>
                <td>{rows[0][2]}</td>
                <td>{rows[0][3]}</td>
              </tr>
              <tr>
              <motion.div 
                initial={{x:100, y:-255, opacity:0.5}}
                animate={{x:0, y:0, opacity:1}}
                transition={{delay:3}}
                ><td>{rows[1][0]}</td></motion.div>
                <td>{rows[1][1]}</td>
                <td>{rows[1][2]}</td>
                <td>{rows[1][3]}</td>
              </tr>
              <tr>
              <motion.div 
                initial={{x:100, y:-255, opacity:0.5}}
                animate={{x:0, y:0, opacity:1}}
                transition={{delay:3}}
                ><td>{rows[2][0]}</td></motion.div>
                <td>{rows[2][1]}</td>
                <td>{rows[2][2]}</td>
                <td>{rows[2][3]}</td>
              </tr>
              <tr>
              <motion.div 
                initial={{x:100, y:-255, opacity:0.5}}
                animate={{x:0, y:0, opacity:1}}
                transition={{delay:3}}
                ><td>{rows[3][0]}</td></motion.div>
                <td>{rows[3][1]}</td>
                <td>{rows[3][2]}</td>
                <td>{rows[3][3]}</td>
              </tr>
            </table>
          </div>

          <div class="button-holder">
            <div class="prev-button" onClick={firstpage}>
              PREVIOUS
            </div>
            <div className="next-button" onClick={secondpage}>
              NEXT
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InitialView;
